import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
  PERMISSION_MAP_CHARTS_WRITE
} from '../../constants'
import ProtectedElement from '../common/helpers/ProtectedElement'
import {clearMapCharts, fetchMapChartsOverviewSuccess} from '../../actions/pages/map-charts-page'
import WithAjax from '../common/helpers/WithAjax'

class MapOverview extends Component {
  constructor(){
    super();
    this.data = []
    this.dataDimensions = []
    this.fetchDimension = this.fetchDimension.bind(this)
    this.onDownloadMapFile = this.onDownloadMapFile.bind(this)

    this.state = {mapFileUrl: ''}

  }
  componentDidMount(){
    this.fetchDimension();
  }
  componentDidUpdate(prevProps){
    if (this.props.overview === null && !this.props.isLoading) {
      this.fetchDimension();
    }
  }
  fetchDimension(){
    let url = 'geo';
    this.props.clearMapCharts();

    this.props.ajax.get(url, true, (data) => {
      this.props.fetchMapChartsOverviewSuccess(data);
      this.dataDimensions = []
      {data.Dimensions.map((element, index) => {
        if(element.IsDraft == false){
          this.dataDimensions.push(element)
        }
        this.setState({mapFileUrl: element.UploadedFileUrl})
      })}
    });
  }
  onDownloadMapFile(e){

  var saveAs = require('file-saver')
  fetch(this.state.mapFileUrl, {
  headers: {
    'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'Authorization': 'Bearer ' + localStorage.getItem('access_token')
  },
  responseType: 'blob'
}).then(response => response.blob())
  .then(blob => saveAs(blob, 'Client-app-map-charts.xlsx'));


  }
  render() {
    if (this.props.overview === null) {
      return (<div />)
    }
    if (this.dataDimensions !== null){
      return(
        <React.Fragment>
          {this.dataDimensions.map((element, index) => (
            <div key={index}>
              <div className="row">
                <div className="col-12">
                  <h5 style={{marginTop: '10px'}}>{element.Label}</h5>
                  <p>{element.Description}</p>
                </div>
              </div>
              <div className="row" style={{marginBottom: '50px'}}>
                {element.MapUrls.map((element, index) => (
                  <div key={index} className="col-12 col-md-4 text-center">
                    <a href={element.Value}>
                      <img src={element.Value} style={{width:'75%'}}/>
                    </a>
                  </div>
                ))}
              </div>
            </div>
          ))}
          <ProtectedElement permission={PERMISSION_MAP_CHARTS_WRITE}>
            <button style={{marginTop: '10px'}}  type="button" className="btn btn-rounded btn-primary" onClick={this.onDownloadMapFile}>Download</button>
          </ProtectedElement>
        </React.Fragment>
      )
    }
  }
}

const mapStateToProps = (state, ownProps) => ({
  overview: state.mapChartsPage.overview,
  isLoading: state.common.isLoading
})
const mapDispatchToProps = dispatch => ({
  clearMapCharts() { dispatch(clearMapCharts()) },
  fetchMapChartsOverviewSuccess(overview) { dispatch(fetchMapChartsOverviewSuccess(overview)) }
})
export default connect(mapStateToProps, mapDispatchToProps)(WithAjax(MapOverview))
